export const accountTabs = [
  "overview",
  "services",
  "users",
  "numbers",
  "devices",
  "features",
  "voicemail",
  "recordings",
  "experiences",
  "routing",
  "billing",
  "orders",
] as const;
export type AccountTab = (typeof accountTabs)[number];
export type PortalRoute = {
  section: string;
  accountId: string | null;
  tab: AccountTab;
};
const staffSections = [
  "staff-email",
  "service-status",
  "overview",
  "inbox",
  "customers",
  "orders",
  "numbers",
  "ports",
  "devices",
  "plans",
  "feature-list",
  "billing",
  "voice",
  "time-temperature",
  "experiences",
  "messages",
  "access",
  "settings",
];
const customerSections = ["overview", "messages", "settings"];
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function refreshOverviewOnNavigate(section: string, admin: boolean) {
  return (
    section === "messages" ||
    (admin &&
      ["inbox", "customers", "orders", "billing", "access"].includes(section))
  );
}

export function readPortalRoute(search: string, admin: boolean): PortalRoute {
  const params = new URLSearchParams(search);
  const section = params.get("section") ?? "overview";
  const accountId = params.get("account");
  const tab = params.get("tab");
  if (section === "account" && accountId && uuid.test(accountId))
    return {
      section,
      accountId,
      tab: accountTabs.includes(tab as AccountTab)
        ? (tab as AccountTab)
        : "overview",
    };
  return {
    section: (admin ? staffSections : customerSections).includes(section)
      ? section
      : "overview",
    accountId: null,
    tab: "overview",
  };
}

export function portalRouteUrl(path: string, route: PortalRoute) {
  const params = new URLSearchParams();
  if (route.section !== "overview") params.set("section", route.section);
  if (
    route.section === "account" &&
    route.accountId &&
    uuid.test(route.accountId)
  ) {
    params.set("account", route.accountId);
    if (route.tab !== "overview") params.set("tab", route.tab);
  }
  const search = params.toString();
  return `${path === "/admin" ? "/admin" : "/customer"}${search ? `?${search}` : ""}`;
}
